"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * MyRegexp class provides regular expressions that
 * are used throughout the application
 */
var MyRegexp = /** @class */ (function () {
    function MyRegexp() {
    }
    MyRegexp.phone = function () {
        return MyRegexp.list['phone'];
    };
    MyRegexp.emailOrPhone = function () {
        return MyRegexp.list['emailOrPhone'];
    };
    MyRegexp.objectId = function () {
        return MyRegexp.list['objectId'];
    };
    MyRegexp.url = function () {
        return MyRegexp.list['url'];
    };
    MyRegexp.email = function () {
        return MyRegexp.list['email'];
    };
    MyRegexp.phoneFormat = function () {
        return MyRegexp.list['phoneFormat'];
    };
    MyRegexp.version = function () {
        return MyRegexp.list['version'];
    };
    MyRegexp.list = {
        'phone': /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/i,
        'email': /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        'objectId': /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i,
        'url': /^((ftp|http|https):\/\/)(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/i,
        'emailOrPhone': /(^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/i,
        'phoneFormat': /[-+()\s]/ig,
        'version': /\d+\.\d+\.\d+/i
    };
    return MyRegexp;
}());
exports.default = MyRegexp;
